import { render, staticRenderFns } from "./rules-content.vue?vue&type=template&id=902d5b1a"
import script from "./rules-content.vue?vue&type=script&lang=js"
export * from "./rules-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/bonuses/rules-content.vue
// module id = 8wXw
// module chunks = 0